import React from "react";
import styles from "./styles.module.scss";

const CorporateActions = () => {
    return (
        <div className={styles.corporateActions}>
            <div>Corporate Actions Component</div>
        </div>
    );
};

export default CorporateActions;
